import React from 'react';

import {
  useVideoContext,
  usePlayer,
  UiEvents,
} from '@loomhq/createhq/dist/video-player';
import { parseGraphqlReaction } from './utils/model';
import {
  useCreateReaction,
  useDeleteReaction,
  useFetchReactions,
} from './hooks/reactions';
import { useSelector } from 'react-redux';
import { selectUserId } from 'selectors/user';

const ReactionsHandler = (): any => {
  const { setReactions, video } = useVideoContext();
  const reactions = useFetchReactions();
  const player = usePlayer(video.id);

  const userId: number = useSelector(selectUserId);

  const createReaction = useCreateReaction();
  const deleteReaction = useDeleteReaction();

  // register for new reaction event
  React.useEffect(() => {
    player?.on([UiEvents.newReaction], createReaction);

    return () => {
      player?.off([UiEvents.newReaction], createReaction);
    };
  }, [createReaction, player]);

  // register for reaction deletion event
  React.useEffect(() => {
    player?.on([UiEvents.deleteReaction], deleteReaction);

    return () => {
      player?.off([UiEvents.deleteReaction], deleteReaction);
    };
  }, [deleteReaction, player]);

  // When reactions change for any reasons, push update to video context
  React.useEffect(() => {
    if (reactions) {
      setReactions(
        reactions.map(reaction => parseGraphqlReaction(reaction, userId))
      );
    }
  }, [setReactions, reactions, userId]);

  return null;
};

export default ReactionsHandler;
